module.exports = __webpack_public_path__ + "img/stock_detail.9597fb67.png";